<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    scrollable

  >
    <v-card
      height="500px"
    >
      <v-text-field
        v-model="term"
        :label="$t('Select Address')"
        class="search-field"
        prepend-inner-icon="search"
        solo
        disabled
        dark
        single-line
        background-color="primary"
        color="white"
        clearable
      />

      <v-card-text
        style="height:450px"
      >

        <v-list
          two-line
          subheader
          dense
        >
          <template
            v-for="item in items"
          >
            <v-divider
              :key="`d-${item.id}`"
            />
            <v-list-tile

              :key="item.id"
              avatar
              @click="select(item)"
            >
              <v-list-tile-action>
                <v-icon color="primary">
                  location_on
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.address_line1 }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ addressState(item) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <div>
                  <v-icon
                    v-if="item.is_default"
                    left
                    color="primary"
                    class="mr-1"
                  >
                    star
                  </v-icon>
                </div>
              </v-list-tile-action>
            </v-list-tile>
          </template>

        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          small
          @click="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          flat
          small
          @click="goto"
        >
          {{ $t('Manage Addresses') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SearchAddress',

  data () {
    return {
      dialog: false,
      id: '',
      term: '',
      items: [],
      resolve: null,
      reject: null
    }
  },

  computed: {
    addressState () {
      return address =>
        `${address.locality}, ${address.administrative_area} ${address.postal_code}`
    }
  },

  methods: {
    async find (id) {
      this.resolve = null
      this.reject = null
      this.dialog = true
      this.id = id

      this.items = await this.$http
        .make('customer', { id })
        .addresses()
        .get()

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    select (item) {
      this.resolve(item)
      this.dialog = false
    },

    cancel () {
      this.resolve(false)
      this.dialog = false
    },

    goto () {
      this.resolve(false)
      this.dialog = false

      const route = this.$router.resolve({ name: 'single_customer', params: { id: this.id } })
      window.open(route.href, '_blank')
    }
  }
}
</script>
